import {
    Component,
    input,
    output,
    signal,
    OnDestroy,
    inject,
    DestroyRef,
    afterNextRender,
} from '@angular/core';

@Component({
    selector: 'app-confirm-dialog',
    standalone: true,
    templateUrl: './confirm-dialog.component.html',
})
export class ConfirmDialogComponent implements OnDestroy {
    private destroyRef = inject(DestroyRef);

    dialogId = input('confirm-dialog');
    title = input('Konfirmasi');
    message = input('Apakah Anda yakin?');
    confirmBtnLabel = input('Konfirmasi');
    cancelBtnLabel = input('Batal');
    confirmBtnClass = input('btn-error');
    cancelBtnClass = input('');

    confirmed = output<(shouldClose?: boolean) => void>();
    cancelled = output<void>();

    isOpen = signal(false);
    isLoading = signal(false);

    private boundEscapeHandler = this.handleEscapeKey.bind(this);

    constructor() {
        afterNextRender(() => {
            document.addEventListener('keydown', this.boundEscapeHandler);
            this.destroyRef.onDestroy(() => {
                document.removeEventListener('keydown', this.boundEscapeHandler);
            });
        });
    }

    ngOnDestroy(): void {
        document.body.style.overflow = '';
    }

    private handleEscapeKey(event: KeyboardEvent): void {
        if (event.key === 'Escape' && this.isOpen() && !this.isLoading()) {
            this.onCancel();
        }
    }

    open(): void {
        this.isLoading.set(false);
        this.isOpen.set(true);
        document.body.style.overflow = 'hidden';
    }

    close(): void {
        this.isOpen.set(false);
        this.isLoading.set(false);
        document.body.style.overflow = '';
    }

    onBackdropClick(event: MouseEvent): void {
        if (event.target === event.currentTarget) {
            this.onCancel();
        }
    }

    onConfirm(): void {
        this.isLoading.set(true);
        const done = (shouldClose = true) => {
            if (shouldClose) {
                this.close();
                return;
            }
            this.isLoading.set(false);
        };
        this.confirmed.emit(done);
    }

    onCancel(): void {
        if (this.isLoading()) return;
        this.cancelled.emit();
        this.close();
    }
}
